import './ScreenHeader.css';
import { getScreenHeaderBackgroundUrl } from './screenHeaderAssets';

type ScreenHeaderProps = {
  /** Visibility of sub_header_background (119:6978). Default: true. */
  showSubHeader?: boolean;
};

/** From Figma title_and_subtitle2 (119:6979) — sub_header + header image. */
export function ScreenHeader({ showSubHeader = true }: ScreenHeaderProps) {
  return (
    <>
      {showSubHeader ? <div className="screen-header__sub" aria-hidden /> : null}
      <img
        className="screen-header__main"
        src={getScreenHeaderBackgroundUrl()}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
